import { getText } from "shared/lib";
import { type TreeDescriptor } from "@/components/treeModule/lib";

import { Dialog, DialogContent, DialogTitle } from "shared/components";
import { MultiStemCircumferenceContent } from "@/components/treeModule/treeMeasurementsHelp/MultiStemCircumferenceContent";

export interface MultiStemCircumferenceDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function MultiStemCircumferenceDialog({
  onOpenChange,
  open,
  treeDescriptor,
}: MultiStemCircumferenceDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="max-h-[95vh] !max-w-[600px] overflow-auto">
        <DialogTitle>{getText("How to measure a tree")}</DialogTitle>

        <MultiStemCircumferenceContent treeDescriptor={treeDescriptor} />
      </DialogContent>
    </Dialog>
  );
}
